import { render } from "./AccountDetailsView.vue?vue&type=template&id=b1c36486"
import script from "./AccountDetailsView.vue?vue&type=script&lang=js"
export * from "./AccountDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__